module.exports = __webpack_public_path__ + "d27bdd09b5a3e1f2ae6bff25df3c5cee.pdf";